/* eslint-disable no-magic-numbers */
/* eslint-disable complexity */
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import Tooltip from 'carbon-react/lib/components/tooltip';

import { QUERY_PARAMS, matchOnboardingRoute } from '@futrli/shared-services';
import { UISystemIcon } from '@futrli/ui-components';
import { Forecast } from '@futrli-sdk/predict';

import { BudgetScenarioName } from './budget-scenario-name';
import { getBudgetDateRange } from '../../dashboard/utils';
import * as styles from './forecasting-title-header.scss';
import { usePredictionsInfoContext } from '../context/predictions-info-context';
import { ChecklistDrawer } from './checklist/checklist-drawer';

export const ForecastingTitleHeader = () => {
  const anchorElRef = useRef<HTMLDivElement | null>(null);

  const [isOpenChecklistDrawer, setIsOpenChecklistDrawer] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const onboardingComplete = searchParams.get(QUERY_PARAMS.ONBOARDING_COMPLETE);


  const { forecast, isConsolidation, isReadOnly, updateForecast } = usePredictionsInfoContext();

  useEffect(() => {
    if (onboardingComplete === 'true') {
      setIsOpenChecklistDrawer(true);
    }
  }, [onboardingComplete]);

  const { pathname } = useLocation();

  const isBudget = forecast?.kind === 'budget';

  const handleOpenChecklistDrawer = () => {
    setIsOpenChecklistDrawer(true);
  };

  const handleCloseChecklistDrawer = () => {
    setIsOpenChecklistDrawer(false);
  };

  if (matchOnboardingRoute(pathname)) {
    return null;
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ marginBottom: isBudget ? 0 : 20 }} className={styles.title}>
          {forecast?.kind === 'live' ? (
            <BudgetScenarioName />
          ) : forecast?.kind === 'budget' ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start'
                }}
              >
                {!isConsolidation && (forecast as Forecast).is_frozen && (
                  <Tooltip
                    message={
                      <FormattedMessage
                        id="predict.predictions.budget_close_from_editing"
                        defaultMessage="This budget is closed from further editing"
                      />
                    }
                    position="top"
                    data-testid="ds-icon-tooltip"
                  >
                    <div style={{ display: 'flex' }}>
                      <UISystemIcon iconName="disabled-icon" width={20} height={20} style={{ marginRight: 10 }} />
                    </div>
                  </Tooltip>
                )}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {!isConsolidation && (forecast as Forecast).is_frozen ? (
                    <span>{forecast?.name}</span>
                  ) : (
                    <BudgetScenarioName />
                  )}
                </div>
              </div>
              {forecast?.kind === 'budget' && forecast.forecast_from_date && (
                <div
                  id="budget-period-title"
                  style={{ display: 'flex', alignItems: 'center', marginBottom: 2, paddingBottom: 20 }}
                  className={styles.budgetPeriodTitle}
                >
                  {!isConsolidation && (forecast as Forecast).is_frozen && <div style={{ width: 30 }} />}
                  {getBudgetDateRange(forecast.forecast_from_date)}
                </div>
              )}
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <BudgetScenarioName />
            </div>
          )}
        </h1>
        {!isConsolidation && !isReadOnly && (
          <div
            ref={anchorElRef}
            style={{ marginLeft: 'auto', marginBottom: isBudget ? 0 : 20 }}
            className={styles.checklist}
            onClick={handleOpenChecklistDrawer}
          >
            <FormattedMessage id="predict.checklist" defaultMessage="Checklist" />
          </div>
        )}
      </div>
      {isConsolidation || isReadOnly ? null : forecast ? (
        <ChecklistDrawer
          isOpen={isOpenChecklistDrawer}
          onClose={handleCloseChecklistDrawer}
          forecast={forecast as Forecast}
          updateForecast={updateForecast}
        />
      ) : null}
    </>
  );
};
